import { useEffect } from "react";
import "../LandingPage.css";

export default function Home() {
  useStickyHeader();
  useSectionHighlighter();
  useCounters();
  useMainCarousel();

  // Ensure banner carousel starts at first slide when component mounts
  useEffect(() => {
    const bannerCarousel = document.getElementById("bannerCarousel");
    if (bannerCarousel) {
      // Reset to first slide
      bannerCarousel.style.transform = "translateX(0%)";
      // Trigger reset event to ensure carousel state is properly reset
      const resetEvent = new CustomEvent("resetBannerCarousel");
      bannerCarousel.dispatchEvent(resetEvent);
    }
  }, []);

  return (
    <>
      {/* Banner Carousel - Only for banner sections */}
      <div className="banner-carousel-container">
        <div className="banner-carousel" id="bannerCarousel">
          {/* Banner 1: Corporate */}
          <div className="banner-carousel-slide">
            <section
              className="banner-section padding-bottom"
              id="BannerSection"
            >
              <div className="container">
                <div className="row align-items-center responsive-screen-991">
                  <div className="col-lg-5 col-md-12 col-sm-12 col-12">
                    <div className="banner-details banner-details-2">
                      <h1>
                        <span style={{ color: "var(--orange-color)" }}>
                          Smart
                        </span>{" "}
                        <span style={{ color: "var(--primary-color)" }}>
                          Mobility
                        </span>{" "}
                        <span style={{ color: "var(--secondry-color)" }}>
                          Solution
                        </span>{" "}
                        <span style={{ color: "var(--red-color)" }}>
                          for your
                        </span>{" "}
                        <span style={{ color: "var(--orange-color)" }}>
                          employee!
                        </span>
                      </h1>
                      <br />

                      {/* <p>Ride with Us, Work with Ease.</p> */}
                      <p style={{ color: "black" }}>
                        Ride a Little Better, Work a Little More Better
                      </p>
                      <br />

                      <a
                        href="#contactFormSection"
                        className="primary-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          document
                            .getElementById("contactFormSection")
                            ?.scrollIntoView({ behavior: "smooth" });
                        }}
                      >
                        <span>Request for Demo</span>
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-7 col-md-12 col-sm-12 col-12">
                    <div className="sec-banner-img text-right">
                      <img src="/assets/images/Group-138.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          {/* Banner 2: School */}
          <div className="banner-carousel-slide">
            <section
              className="banner-section padding-bottom"
              id="schoolsBannerSection"
            >
              <div className="container">
                <div className="row align-items-center responsive-screen-991">
                  <div className="col-lg-5 col-md-12 col-sm-12 col-12">
                    <div className="banner-details banner-details-2">
                      <h1>
                        {/* Smart & Reliable Mobility Solution for Schools, Students
                        & Parents */}
                        <span style={{ color: "var(--orange-color)" }}>
                          Smart & Reliable
                        </span>{" "}
                        <span style={{ color: "var(--primary-color)" }}>
                          Mobility Solution
                        </span>{" "}
                        <span style={{ color: "var(--secondry-color)" }}>
                          Solution
                        </span>{" "}
                        <span style={{ color: "var(--red-color)" }}>
                          for Schools,
                        </span>{" "}
                        <span style={{ color: "var(--orange-color)" }}>
                          Students!
                        </span>
                      </h1>
                      <br />
                      <p style={{ color: "black" }}>
                        {/* Designed to address more and more of your daily
                        lifestyle needs. Commute, eat, deliver and pay with one
                        App. */}
                        Safe Ride Guaranteed.
                      </p>

                      <br />
                      <a
                        href="#contactFormSection"
                        className="primary-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          document
                            .getElementById("contactFormSection")
                            ?.scrollIntoView({ behavior: "smooth" });
                        }}
                      >
                        <span>Request for Demo</span>
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-7 col-md-12 col-sm-12 col-12">
                    <div className="sec-banner-img text-right">
                      <img src="/assets/images/Hero-bg-2.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        {/* Banner Carousel Dot Indicators */}
        <div className="banner-carousel-dots">
          <button
            className="carousel-dot active"
            id="dot1"
            data-slide="0"
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              border: "2px solid rgba(128, 128, 128, 0.5)",
              backgroundColor: "rgba(128, 128, 128, 0.3)",
              cursor: "pointer",
              transition: "all 0.3s ease",
              outline: "none",
              boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
            }}
          ></button>
          <button
            className="carousel-dot"
            id="dot2"
            data-slide="1"
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              border: "2px solid rgba(128, 128, 128, 0.5)",
              backgroundColor: "rgba(128, 128, 128, 0.3)",
              cursor: "pointer",
              transition: "all 0.3s ease",
              outline: "none",
              boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
            }}
          ></button>
        </div>
      </div>

      {/* All other content outside the carousel */}

      <section
        className="about-section padding-bottom"
        id="AboutSection"
        style={{ marginTop: "60px" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title">
                <h2> About US </h2>
              </div>
            </div>

            <div className="col-lg-8 col-md-12 col-sm-12 col-12">
              <div className="counters-main">
                <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div className="count-up">
                      <p
                        className="counter-count plus"
                        style={{ color: "var(--primary-color)" }}
                      >
                        900
                      </p>
                      <h3>Corporate</h3>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div className="count-up">
                      <p
                        className="counter-count plusM"
                        style={{ color: "var(--secondry-color)" }}
                      >
                        5.7
                      </p>
                      <h3>Customer Base</h3>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div className="count-up">
                      <p
                        className="counter-count"
                        style={{ color: "var(--red-color)" }}
                      >
                        8
                      </p>
                      <h3>Countries</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="about-map text-center">
                <img
                  src="/assets/images/Map.png"
                  alt=""
                  className="img-fluid"
                  style={{ maxWidth: "60%", height: "auto" }}
                />
              </div>
            </div>
            <div className="col-12">
              <div className="about-content">
                <p>
                  Little is a pan-African " <span>every</span>
                  <span>day</span> <span>everything</span> " app and one of the
                  Africa's largest ride-hailing service company, serving cities
                  across{" "}
                  <span>
                    India, Kenya, Uganda, Tanzania, Ethiopia, Somalia, Senegal,
                    and Ghana
                  </span>
                  . Little app offers mobility, delivery and payment solutions
                  by connecting customers to drivers and delivery agents,
                  enabling convenience and transparency for hundreds of
                  thousands of customers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="video-showcase-section padding-bottom"
        id="VideoShowcaseSection"
      >
        <div className="container">
          <div className="section-title">
            <h2>Little Live in Action</h2>
          </div>

          <div className="video-showcase-container">
            {/* <div className="video-wrapper">
              <video
                width="90%"
                height="500"
                controls
                autoPlay
                muted
                loop
                style={{
                  borderRadius: "20px",
                  boxShadow: "0 15px 40px rgba(0, 0, 0, 0.2)",
                  width: "90%",
                  height: "auto",
                  minHeight: "500px",
                  maxHeight: "550px",
                  objectFit: "cover",
                  margin: "0 auto",
                  display: "block",
                }}
              >
                <source src="/assets/images/video.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div> */}

            <div className="video-wrapper">
              <div
                style={{
                  borderRadius: "20px",
                  boxShadow: "0 15px 40px rgba(0, 0, 0, 0.2)",
                  width: "90%",
                  height: "500px",
                  maxHeight: "550px",
                  margin: "0 auto",
                  display: "block",
                  overflow: "hidden",
                }}
              >
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/q_nXnRu1D30"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    border: "none",
                    borderRadius: "20px",
                  }}
                ></iframe>
              </div>
            </div>

            <div className="video-description">
              <div className="description-content">
                <p className="platform-description">
                  The Corporate platform allows companies to scale
                  transportation needs across the company. Offering real time
                  visibility that allows companies to minimize the risk as well
                  as optimize their transportation operations.
                </p>

                <div className="services-overview">
                  <p className="services-intro">
                    Little is a one stop shop that allows corporates to utilize
                    multiple mobility services such as:
                  </p>

                  <div className="services-list">
                    <span className="service-tag">Executive Vehicles</span>
                    <span className="service-tag">Taxi</span>
                    <span className="service-tag">Shuttle</span>
                    <span className="service-tag">Logistics</span>
                  </div>

                  <p className="platform-benefits">
                    The Corporate platform allows companies to scale
                    transportation needs across the company. Offering real time
                    visibility that allows companies to minimize the risk
                    associated with the transportation budget and controls.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="services-category">
            <div className="row">
              <div className="col-12">
                <h5>
                  Little is a one stop shop that allows corporates to utilize
                  multiple mobility services such as :
                </h5>
                <div className="services-category-list text-center mb-3">
                  <span className="category-list-item">Executive Vehicles</span>
                  <span className="category-list-item">Taxi</span>
                  <span className="category-list-item">Shuttle</span>
                  <span className="category-list-item">Logistics</span>
                </div>
                <div className="services-category-list-details">
                  <p>
                    The Corporate platform allows companies to scale
                    transportation needs across the company. Offering real time
                    visibility that allows companies to minimize the risk
                    associated with the transportation budget and controls
                  </p>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
}

function useStickyHeader() {
  useEffect(() => {
    const onScroll = () => {
      const el = document.querySelector(".page-header");
      if (!el) return;
      if (window.scrollY > 50) el.classList.add("stickey");
      else el.classList.remove("stickey");
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
}

function useSectionHighlighter() {
  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");
    const handler = () => {
      const scrollY = window.pageYOffset;
      sections.forEach((current) => {
        const sectionHeight = current.offsetHeight;
        const sectionTop = current.offsetTop - 50;
        const id = current.getAttribute("id");
        const link = document.querySelector(`.navigation a[href*=${id}]`);
        if (!link) return;
        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight)
          link.classList.add("active");
        else link.classList.remove("active");
      });
    };
    window.addEventListener("scroll", handler);
    handler();
    return () => window.removeEventListener("scroll", handler);
  }, []);
}

function useCounters() {
  useEffect(() => {
    const elems = document.querySelectorAll(".counter-count");
    elems.forEach((el) => {
      const targetText = el.textContent || "0";
      const target = parseFloat(targetText);
      const start = performance.now();
      const duration = 4000;
      const isPlusM = el.classList.contains("plusM");
      // const suffix = el.classList.contains("plus") ? "+" : isPlusM ? "M+" : "";
      const animate = (t) => {
        const progress = Math.min((t - start) / duration, 1);
        const value = Math.ceil(progress * target);
        // During animation, show just the number
        el.textContent = `${value}`.replace(/\.$/, "");
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          // Final value with suffix
          el.textContent = `${target}`.replace(/\.$/, "");
        }
      };
      requestAnimationFrame(animate);
    });
  }, []);
}

function useMainCarousel() {
  useEffect(() => {
    const carousel = document.getElementById("bannerCarousel");
    const dots = document.querySelectorAll(".carousel-dot");

    console.log("Banner carousel elements:", { carousel, dots });

    if (!carousel || dots.length === 0) {
      console.log("Missing carousel elements");
      return;
    }

    let currentSlide = 0;
    const totalSlides = 2;
    let autoSlideInterval;

    const updateCarousel = () => {
      const translateX = -currentSlide * 50;
      carousel.style.transform = `translateX(${translateX}%)`;

      // Update dot indicators
      dots.forEach((dot, index) => {
        if (index === currentSlide) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });
    };

    const goToSlide = (slideIndex) => {
      currentSlide = slideIndex;
      updateCarousel();
    };

    const nextSlide = () => {
      // Auto-advance to next slide
      currentSlide = (currentSlide + 1) % totalSlides;
      updateCarousel();
    };

    const prevSlide = () => {
      // Previous slide (left movement)
      currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
      updateCarousel();
    };

    const resetToFirstSlide = () => {
      currentSlide = 0;
      updateCarousel();
      stopAutoSlide();
      startAutoSlide();
    };

    const startAutoSlide = () => {
      autoSlideInterval = setInterval(nextSlide, 15000); // 20 seconds
    };

    const stopAutoSlide = () => {
      if (autoSlideInterval) {
        clearInterval(autoSlideInterval);
      }
    };

    // Event listeners for dot indicators - work like testimonial carousel
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        stopAutoSlide();
        if (index > currentSlide) {
          // Moving forward (right)
          nextSlide();
        } else if (index < currentSlide) {
          // Moving backward (left)
          prevSlide();
        }
        startAutoSlide();
      });
    });

    // Listen for reset event from navigation
    carousel.addEventListener("resetBannerCarousel", resetToFirstSlide);

    // Pause auto-slide on hover
    carousel.addEventListener("mouseenter", stopAutoSlide);
    carousel.addEventListener("mouseleave", startAutoSlide);

    // Start auto-slide
    startAutoSlide();

    return () => {
      stopAutoSlide();
      dots.forEach((dot) => {
        dot.removeEventListener("click", goToSlide);
      });
      carousel.removeEventListener("resetBannerCarousel", resetToFirstSlide);
      carousel.removeEventListener("mouseenter", stopAutoSlide);
      carousel.removeEventListener("mouseleave", startAutoSlide);
    };
  }, []);
}
